import React from "react";

const PieChart = ({ data, text = {}, externalTotal = null }) => {
  const siteName = data.siteName || "Unknown Site";

  const keys = Object.keys(data).filter((key) => key !== "siteName");
  const [key1, key2] = keys;

  const val1 = data[key1] || 0;
  const val2 = data[key2] || 0;
  const categorizedTotal = val1 + val2;
  const displayTotal = externalTotal !== null ? externalTotal : categorizedTotal;

  // Use categorizedTotal for percentage calculation to ensure they add up to 100%
  const percent1 = categorizedTotal > 0 ? val1 / categorizedTotal : 0;
  const percent2 = categorizedTotal > 0 ? val2 / categorizedTotal : 0;

  const RADIUS = 16;
  const CIRCUMFERENCE = 2 * Math.PI * RADIUS;
  const arc1 = CIRCUMFERENCE * percent1;
  const arc2 = CIRCUMFERENCE * percent2;

  return (
    <div className="w-[307px] text-white rounded-xl items-center">
      <div>{siteName}</div>

      <div className="flex mt-6">
        <div className="relative w-[133px] h-[133px] flex-shrink-0">
          <svg className="w-full h-full" viewBox="0 0 36 36">
            {categorizedTotal === 0 ? (
              <circle
                cx="18"
                cy="18"
                r={RADIUS}
                fill="transparent"
                stroke="#555"
                strokeWidth="4"
              />
            ) : (
              <>
                <circle
                  cx="18"
                  cy="18"
                  r={RADIUS}
                  fill="transparent"
                  stroke="#333"
                  strokeWidth="4"
                />
                <circle
                  cx="18"
                  cy="18"
                  r={RADIUS}
                  fill="transparent"
                  stroke="#5A3EFF"
                  strokeWidth="4"
                  strokeDasharray={`${arc1} ${CIRCUMFERENCE - arc1}`}
                  strokeDashoffset={CIRCUMFERENCE * 0.25}
                  transform="rotate(-90 18 18)"
                />
                <circle
                  cx="18"
                  cy="18"
                  r={RADIUS}
                  fill="transparent"
                  stroke="#00A3FF"
                  strokeWidth="4"
                  strokeDasharray={`${arc2} ${CIRCUMFERENCE - arc2}`}
                  strokeDashoffset={CIRCUMFERENCE * 0.25 - arc1}
                  transform="rotate(-90 18 18)"
                />
              </>
            )}
          </svg>

          <div className="absolute inset-0 flex flex-col justify-center items-center text-center">
            <p className="text-xs">{text.Total || "Total"}</p>
            <p className="font-bold text-lg">{displayTotal}</p>
          </div>
        </div>

        <div className="ml-7 text-sm min-w-0 flex-1">
          <div className="mb-1">
            <div className="flex items-center gap-2 h-[30px]">
              <span
                className={`w-3 h-3 block rounded-full flex-shrink-0 ${
                  categorizedTotal === 0 ? "bg-gray-500" : "bg-[#5A3EFF]"
                }`}></span>
              <span className="whitespace-nowrap">{text.dot1 || key1}</span>
            </div>
            <div className="ml-5 h-[30px] items-center flex">
              {(percent1 * 100).toFixed(1)}% - {val1}
            </div>
          </div>

          <div>
            <div className="flex items-center gap-2 h-[30px] mt-1">
              <span
                className={`w-3 h-3 block rounded-full flex-shrink-0 ${
                  categorizedTotal === 0 ? "bg-gray-500" : "bg-[#00A3FF]"
                }`}></span>
              <span className="whitespace-nowrap">{text.dot2 || key2}</span>
            </div>
            <div className="ml-5 h-[30px] items-center flex">
              {(percent2 * 100).toFixed(1)}% - {val2}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PieChart;
